import { valueOrDefault } from "../Util";

class FeatureSummary {
    
    /**
     * 
     * @param {*} options {
     *  element: {react element},
     *  order: int
     * }
     */
    constructor(options){
        this.element = options.element;
        this.order = valueOrDefault(options.order, 1);
    }

    static compare(featureSummary1, featureSummary2){
        return featureSummary1.order - featureSummary2.order;
    }
}

export default FeatureSummary;